// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPackagePriceResponse

export type BillingPackagePriceApiResponse = {
	id: number;
	amount: number;
	frequency: number;
};

export type BillingPackagePrice = {
	id: number;
	amount: number;
	frequency: number;
};

export function hydrateBillingPackagePrice(data: BillingPackagePriceApiResponse): BillingPackagePrice {
	return { ...data };
}